
import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';

import name from '../images/name.svg';
import tel from '../images/tel.svg';
import email from '../images/email.svg';
import address from '../images/address.svg';
import job from '../images/job.svg';

import OrderStatus from '../components/OrderStatus';

export default function Registration() {
    return(
        <div className="container-fluid p-0 mt-4 mb-0">

          <PageHeader/>

          <div className="container">
            
            {/* breadcumb */}
            <div className="row">
              <div className="col-12">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><a href="/">Home</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Loyalty Registration</li>
                  </ol>
                </nav>
              </div>
            </div>
            {/* breadcumb */}

            {/* order status box */}
            <div className="row">
              <OrderStatus/>
            </div>
            {/* order status box */}

            {/* reg form */}
            <div className="row">
              <div className="col-12">
                <form>

                  <div className="form-floating mb-3">
                    <input type="email" className="form-control" id="floatingInput" placeholder="name@example.com"></input>
                    <label for="floatingInput">Name *</label>
                    {/* icon */}
                    <img src={name} alt='' className='d-block form_icon' style={{ width: '17px' }}></img>
                    {/* icon */}
                  </div>

                  <div className="form-floating mb-3">
                    <input type="email" className="form-control" id="floatingInput" placeholder="name@example.com"></input>
                    <label for="floatingInput">Mobile No.*</label>
                    {/* icon */}
                    <img src={tel} alt='' className='d-block form_icon' style={{ width: '17px' }}></img>
                    {/* icon */}
                  </div>

                  <div className="form-floating mb-3">
                    <input type="date" className="form-control" id="floatingInput" placeholder="name@example.com"></input>
                    <label for="floatingInput">Date of Birth</label>
                  </div>

                  <div className="form-floating mb-3">
                    <input type="email" className="form-control" id="floatingInput" placeholder="name@example.com"></input>
                    <label for="floatingInput">Email address</label>
                    {/* icon */}
                    <img src={email} alt='' className='d-block form_icon' style={{ width: '17px' }}></img>
                    {/* icon */}
                  </div>

                  <div className="form-floating mb-3">
                    <textarea className="form-control" placeholder="Leave a comment here" id="floatingTextarea2" style={{height: '100px'}}></textarea>
                    <label for="floatingTextarea2">Address *</label>
                    {/* icon */}
                    <img src={address} alt='' className='d-block form_icon' style={{ width: '17px' }}></img>
                    {/* icon */}
                  </div>

                  <div className="form-floating mb-3">
                    <input type="email" className="form-control" id="floatingInput" placeholder="name@example.com"></input>
                    <label for="floatingInput">Place of Work</label>
                    {/* icon */}
                    <img src={job} alt='' className='d-block form_icon' style={{ width: '17px' }}></img>
                    {/* icon */}
                  </div>

                  <div className="col-12 text-center">
                    <button type="button" class="btn d-block black_btn mb-3 m-auto" style={{ width: '200px' }}>REGISTER</button>
                  </div>
                  

                </form>
              </div>
            </div>
            {/* reg form */}

          </div>

           <Footer/>
        </div>
    );
};